import { useDblIntl } from "@/pages/datalab/utils/utils";
import React from "react";
import { Button, Modal } from "tea-component";

const UnPublishDashboardModal = (props: any) => {
  const { closeFunc, confirmFunc, record } = props;
  const { dblFormatMessage, commonFormatMessage } = useDblIntl("myAnalysis");

  return <>
    <Modal
      visible={true}
      onClose={closeFunc}
    >
      <Modal.Body>
        <Modal.Message
          message={dblFormatMessage("sure_to_unpublish_dashboard_title")}
          description={dblFormatMessage("sure_to_unpublish_dashboard_message")}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="primary"
          onClick={() => {
            closeFunc();
            confirmFunc();
          }}
        >
          {commonFormatMessage("confirm")}
        </Button>
        <Button
          type="weak"
          onClick={() => {
            closeFunc();
          }}
        >
          {commonFormatMessage("cancel")}
        </Button>
      </Modal.Footer>
    </Modal>
  </>;

};

export default UnPublishDashboardModal;